<div class="uni-nav-toggle" (click)="onToggleNav()">
  <i
    class="uni-nav-toggle__icon far fa-chevron-left"
    [ngClass]="{ 'is-collapsed': isNavCollapsed$ | async }"
  ></i>
</div>
